import _ from 'lodash';
import LectureItem from './LectureItem';

function Lectures({ redeemdLectures, code }) {
    return (
        <section className="container flex flex-wrap items-center justify-center gap-10 pt-5 pb-10 mx-auto md:px-16 w-[95%] lg:w-[85%]">
            {_.isArray(redeemdLectures) ? (
                redeemdLectures?.map((lecture) => {
                    return <LectureItem lecture={lecture} key={lecture.id} code={code} />;
                })
            ) : (
                <LectureItem code={code} lecture={redeemdLectures} key={redeemdLectures.id} />
            )}
        </section>
    );
}

export default Lectures;
